export default __webpack_public_path__ + "static/media/dropdownIcon.3125cf40.svg";